<template>
    <div class="controlSet">
        <div class="page-header">
            <page-header></page-header>
            <div class="option-select">
                <template>
                    <el-select class="charts-input" v-model="option.sys_alias" @change="changeOption(true)"
                               placeholder="请选择">
                        <el-option v-for="item in sys_alias" :key="item.id" :label="item.label" :value="item.val">
                        </el-option>
                    </el-select>
                </template>
                <div class="charts-input">
                    <el-button type='primary' :loading="loading" @click="changeOption(false)">{{loading ? '正在加载' :
                        '手动刷新'}}
                    </el-button>
                </div>
            </div>
        </div>

        <div class="css-margin-top">
            <div class="box-card m-card" body-style="{min-height:'300px'}">
                <loading v-if="loading"></loading>
                <template v-else>
                    <div class="clearfix chars-header">
                        <span class="card-header-title">参数设置</span>

                        <div>
                            <el-button type="success" v-show="!option.isEdit" size="small" plain @click="openEdit">编辑
                            </el-button>

                        </div>
                    </div>
                    <!-- isMobile table -->
                    <div class="time-show">
                        {{option.time_stamp}}
                    </div>
                    <div  class="card-body">
                            <div class="m-table">
                                <div class="m-table-li" v-for="(item,index) in confData">
                                    <div class="m-table-label">
                                       {{item.name}}
                                    </div>
                                    <div class="m-table-input">
                                        <div class="edit-input">
                                            <p v-if="!option.isEdit">{{item.data}}</p>
                                            <el-input v-else size="small"
                                                      v-model="item.data"
                                                      @change="checkInputNumber(item.data,index)"
                                                      ></el-input>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>
                </template>

            </div>

        </div>
        <Mconfirm @cancel="closeEdit" :loading="loading"  @define="saveDeviceConf"  :show="option.isEdit&&!loading"></Mconfirm>
    </div>
</template>

<script>
    import {
        mapState
    } from "vuex";
    import Lib from "../../lib/lib.js";
    import pageHeader from "../../components/tempControl/header";
    import loading from "../../components/common/loading";
    import Mconfirm from "../../components/tempControl/Mconfirm"
    import _ from "lodash";

    export default {
        name: "controlSet",
        components: {
            pageHeader,
            loading,
            Mconfirm
        },
        data() {
            return {
                option: {
                    sys_alias: "",
                    isEdit: false,
                    time_stamp: ""
                },
                test: "",
                loading: "",
                sys_alias: [],
                val: "",
                confData: [],
                isRepeat: false,
                floatDataIndexStart: 24, 
                floatDataIndexEnd: 45, 
                saveConf:{
                    show:true
                },
                id_of_setinterval:''

            };
        },
        computed: mapState({
            isMobile: state => state.isMobile,
            deviceInfo: state => state.deviceInfo,
            userInfo: state => state.userInfo,
            config:state=>state.config
        }),
        created() {
            this.creatAliasMeun(this.deviceInfo.alias_m);
            this.option.sys_alias = "1";
        },
        mounted() {
            for (let i = 0; i < 1; i++) {
                this.changeOption(true);
                Lib.M.selectInputFoc();
            }
            this.timingLoad('OPEN')
        },
        beforeDestroy() {
            this.loading = false;
            this.timingLoad('CLOSE')

        },
        methods: {
            /**
             * 创建窑号选框
             * @argument MaxAlias 最大窑数
             */
            creatAliasMeun(MaxAlias) {
                for (let i = 0; i < MaxAlias; i++) {
                    this.sys_alias.push({
                        val: `${i + 1}`,
                        label: `${i + 1}号窑`
                    });
                }
            },
            changeOption(type){
                this.loading = true;
                this.confData = [];
                let that = this;
                this.loadDeviceSettings(type, (is_succ)=>{
                    that.loadControlConf(type);
                });
            },

            timingLoad(type){
                if (type === "OPEN") {
                    this.id_of_setinterval = setInterval(() => {
                        this.loadControlConf(false);
                    }, this.config.refreshInterval?this.config.refreshInterval:30000);
                } else {
                    clearInterval(this.id_of_setinterval);
                }
            },
            loadDeviceSettings(is_cache, callback){
                this.loading = true
                let params = {
                    sys_alias: this.option.sys_alias,
                    is_cache: is_cache,
                    device_id: this.deviceInfo.device_id
                }
                if (this.userInfo.identity === "USER") {
                    params.auth_token = this.userInfo.token;
                } else {
                    params.customer_token = this.userInfo.token;
                }
                Lib.api.loadDeviceSetting(params, (data) => {
                    if (data.payload && data.payload.data) {
                        try {
                            let jsonData = JSON.parse(data.payload.data);
                            delete jsonData.oother;
                            delete jsonData.isSuccess;
                            delete jsonData.msg;
                            console.log("device setting:", jsonData);
                            this.floatDataIndexStart = jsonData.zkcsUchar + jsonData.zkcsChar + jsonData.zkcsUint + jsonData.zkcsInt + jsonData.zkcsUlong + jsonData.zkcsLong;
                            this.floatDataIndexEnd = this.floatDataIndexStart+ jsonData.zkcsFloat;
                        } catch (err) {
                            console.log(err);
                        }
                        if(callback){
                            callback();
                        }
                    } else {
                        if (!is_cache) {
                            this.loadDeviceSettings(true, callback);
                        }else{
                            if(callback){
                                callback();
                            }
                        }
                    }
                });
            },
            loadControlConf(is_cache) {

                let params = {
                    conf_type: "control",
                    sys_alias: this.option.sys_alias,
                    device_id: this.deviceInfo.device_id,
                    is_cache: is_cache
                };
                if (this.userInfo.identity === "USER") {
                    params.auth_token = this.userInfo.token;
                } else {
                    params.customer_token = this.userInfo.token;
                }
                Lib.api.loadDeviceConf(params, data => {
                    this.loading = false;
                    // 确认数据是否更新，否则只读
                    if (data.status_code === "SUCCEEDED") {

                    } else {
                        this.$message({
                            message: "网络连接超时：" + data.msg,
                            type: "warning"
                        });
                        if (!this.isMobile) {
                            this.$notify.info({
                                title: "温馨提示",
                                message: "无法连接设备时，无法进行参数修改操作",
                                duration: 3000,
                                offset: 60
                            });
                        }
                        this.closeEdit();
                        if (!this.isRepeat) {
                            this.isRepeat = true
                            this.loadControlConf(false)
                        }

                    }
                    if (data.payload && data.payload.data) {
                        this.confData = this.dealDateFn(data, "load");
                        this.option.time_stamp = data.payload.time_stamp;
                    }
                });
            },
            saveDeviceConf() {
                this.loading = true;
                let payload = this.dealDateFn(this.confData, "post");
                if (payload == false) {
                    this.$message.error("参数错误");
                    return false;
                } else {
                    payload.devNo = this.option.sys_alias * 1;
                    payload = JSON.stringify(payload);
                }
                let params = {
                    conf_type: "control",
                    sys_alias: this.option.sys_alias.toString(),
                    device_id: this.deviceInfo.device_id,
                    payload: payload
                };
                if (this.userInfo.identity === "USER") {
                    params.auth_token = this.userInfo.token;
                } else {
                    params.customer_token = this.userInfo.token;
                }
                console.log(params);
                Lib.api.setDeviceConf(params, data => {
                    if (data.status_code === "SUCCEEDED") {
                        this.$message.success("修改成功");
                        this.loadControlConf(false);
                        this.closeEdit();
                    } else {
                        this.$message.error(`修改失败：${data.msg}`);
                        this.loading = false;
                    }
                });
            },
            // 处理获取到的配置数据
            dealDateFn(data, type) {
                let confData;
                if (type === "load") {
                    let jsonData = JSON.parse(data.payload.data);
                    confData = [];
                    if (jsonData.oother) {
                        delete jsonData.oother;
                        if (jsonData.msg) {
                            delete jsonData.msg;
                            delete jsonData.isSuccess;
                        }
                    }
                    this.test = jsonData;
                    let jsonDataIndex = 0;
                    for (let key in jsonData) {
                        if (jsonData.hasOwnProperty(key)) {
                            let item = jsonData[key],
                                precision = 0,
                                step = 1, 
                                max,
                                min;
                            if (jsonDataIndex < 11) {
                                max = 255;
                                min = 0;
                            } else if (jsonDataIndex < this.floatDataIndexStart) {
                                max = 65565;
                                min = 0;
                            } else if (jsonDataIndex < this.floatDataIndexEnd) {
                                max = 35575;
                                min = -35575;
                                if (precision<=0){
                                    precision = 1;
                                    item = item.toFixed(precision);
                                    console.log(item, precision);
                                }
                            }
                            confData.push({
                                name: key,
                                data: item,
                                max: max,
                                min: min
                            });
                        }
                        jsonDataIndex++;
                    }
                } else {
                    confData = {};
                    for (let i = 0; i < data.length; i++) {
                        let item = data[i];
                        if (data[i].data === "") {
                            return false;
                        }
                        confData[item.name] = _.round(item.data, 2);
                        if (i < this.floatDataIndexStart) {
                            confData[item.name] = _.round(item.data);
                        }
                    }
                }
                console.log(confData);
                return confData;
            },
            // 检查输入是否是两位小数
            checkInputNumber(val, index) {
                // this.confData[index].data=_.round(val,2)
                // return _.round(val,2)
            },
            // 打开编辑
            openEdit() {
                if (this.userInfo.role === "manager" || this.userInfo.role === "admin") {
                    this.option.isEdit = true;
                    this.changeOption(false);
                  this.timingLoad('CLOSE');

                } else {
                    this.$message.error("权限不足，修改失败");
                }
            },
            closeEdit() {
              this.timingLoad('OPEN');
              this.option.isEdit = false;
            }
        }
    };
</script>

<style scoped>

    .body-style {
        min-height: 300px;
    }

    .set-option {
        display: flex;
        justify-content: space-between;
    }

    .table-list {
        display: flex;
        width: 100%;
    }

    .el-card box-card {
        width: 100%;
    }

    .chars-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .m-table-li{
        padding:0px 10px;;
        display: flex;
        align-items: center;
    }
    .m-table-li .m-table-label{
        width:60%
    }
    .m-table-li .m-table-input{

        width:40%
    }
    .time-show{
        margin: 15px auto;
        text-align: center;
        color: red;
        font-size: 20px;
    }






    .edit-input {
        margin: 9px 0;
    }
</style>





// WEBPACK FOOTER //
// controlSet.vue?17d85296